import React from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import Row from 'components/common/Row';
import CommonImage from 'components/common/CommonImage';
import Text from 'components/common/Text';
import { ICON_NAVIGATE_BACK } from 'assets/icons';
import { SettlementsNode } from 'containers/SettlementRequest/graphQL/types';
import SettlementBadge from 'containers/SettlementRequest/components/SettlementBadge';
import Column from 'components/common/Column';
import { HEADER_HEIGHT } from 'constants/style';

interface DetailHeaderIProps {
  isMobile: boolean;
  settlement: SettlementsNode;
}

const DetailHeader: React.FC<DetailHeaderIProps> = props => {
  const { isMobile, settlement } = props;

  const navigate = useNavigate();

  if (isMobile) {
    return (
      <Row
        justifyContent="flex-start"
        gap="16px"
        style={{
          position: 'sticky',
          top: 0,
          padding: '32px 0',
          width: '100%',
          background: '#fff',
        }}
      >
        <CommonImage
          src={ICON_NAVIGATE_BACK}
          onClick={() => {
            navigate(-1);
          }}
        />
        <Column gap="4px" align="flex-start">
          <Row gap="8px">
            <SettlementBadge
              status={
                settlement.invoice !== null ? settlement.invoice.status : null
              }
            />
            <Text color="#1b1c1e" size="24px" style={{ lineHeight: '36px' }}>
              {settlement.title.slice(6, 15)} 상세내역
            </Text>
          </Row>
          <Text color="#989BA2" size="14px" weight={400}>
            {dayjs(settlement.startedDate).format('M월 D일(dd)')}부터{' '}
            {dayjs(settlement.endedDate).format('M월 D일(dd)')}까지
          </Text>
        </Column>
      </Row>
    );
  }

  return (
    <Row
      justifyContent="flex-start"
      gap="16px"
      style={{
        position: 'sticky',
        top: `${HEADER_HEIGHT}px`,
        padding: '32px 0',
        width: '100%',
        background: '#fff',
      }}
    >
      <CommonImage
        src={ICON_NAVIGATE_BACK}
        onClick={() => {
          navigate(-1);
        }}
      />
      <Row gap="16px">
        <Row gap="8px">
          <SettlementBadge
            status={
              settlement.invoice !== null ? settlement.invoice.status : null
            }
          />
          <Text color="#1b1c1e" size="24px" style={{ lineHeight: '36px' }}>
            {settlement.title.slice(6, 15)} 상세내역
          </Text>
        </Row>
        <Text color="#989BA2" size="14px" weight={400}>
          {dayjs(settlement.startedDate).format('M월 D일(dd)')}부터{' '}
          {dayjs(settlement.endedDate).format('M월 D일(dd)')}까지
        </Text>
      </Row>
    </Row>
  );
};

export default DetailHeader;
